import { Component, HostBinding, inject, Input } from '@angular/core';
import { ScrollService } from '@innogy/utils-deprecated';

@Component({
  selector: 'wl-sticky-wrapper',
  templateUrl: './sticky-wrapper.component.html',
  standalone: true,
})
export class StickyWrapperComponent {
  readonly #scrollService = inject(ScrollService);

  @HostBinding('class.sticky-top')
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input()
  sticky = true;

  @HostBinding('style')
  get style() {
    if (!this.sticky) {
      return {};
    }
    return {
      top: `${this.#scrollService.verticalScrollOffset() + 20}px`,
      'z-index': 'auto',
    };
  }
}
